export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ17.0c1dcb01.mp3";